module.exports = __webpack_public_path__ + "media/images/logo-5bfb38a432a29cdf818aea71daad43d8.png";